import React, { Component } from 'react'
import videojs from 'video.js'

import 'video.js/dist/video-js.css'


export default class VideoPlayer extends Component {

  componentDidMount(prevProps, prevState) {
    const options = {
      ...this.props,
      sources: [{
        src: this.props.src,
        type: 'video/mp4'
      }]
    }
    this.player = videojs(this.videoNode, options);
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.src !== this.props.src) {
      this.player.src(this.props.src)
      this.player.play()
    }
  }

  render() {
    return (
      <div className="video-player-container">
        <div data-vjs-player>
          <video ref={ node => this.videoNode = node } className="video-js"></video>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js